import { LabelValueInterface } from "../models/common.models";

export const DEFAULT_CURRENCIES: LabelValueInterface[] = [
  {
    value: "BRL",
    label: "R$",
  },
  {
    value: "USD",
    label: "$",
  },
  {
    value: "EUR",
    label: "€",
  },
];


const LANGUAGE_I18N_ROOT = "private-home-page:filterForm.language";
export const DEFAULT_LANGUAGES: LabelValueInterface[] = [
  {
    value: "a47eaf57-c6c7-4078-9093-56468c8adfcb",
    label: `${LANGUAGE_I18N_ROOT}.english`
  },
  {
    value: "284fe905-0b1b-4eb1-ad9f-0da1f44763c5",
    label: `${LANGUAGE_I18N_ROOT}.spanish`
  },
  {
    value: "e57441cf-eb7a-4b0c-b947-68f8ee5dbb77",
    label: `${LANGUAGE_I18N_ROOT}.french`
  },
];


export enum Events {
  LOGIN_PLATFORM = "login_platform",
  SEARCH = "search",
  VIEW_PROFILE = "view_profile",
  UNLOCK_CV = "unlock_profile",
  ADD_TAG = "add_tag",
  ADD_COMMENT = "add_comment",
  REMOVE_TAG = "remove_tag",
  SELECT_PROCESS_CHANGE_TA = "select_process_change_ta",
  SELECT_PROCESS_FILTER_BY_EMAIL = "select_process_filter_by_email",
  VERTICAL_FILTER_BY_EMAIL = "vertical_filter_by_email",
  SELECT_PROCESS_FILTER_BY_STATUS = "select_process_filter_by_status",
  SELECT_PROCESS_FILTER_BY_FEEDBACK = "select_process_filter_by_feedback",
  ADD_FEEDBACK = "add_feedback",
  OPEN_VERTICAL = "open_vertical",
  INVITE_TA = "invite_ta",
  PAGE_VIEW = "page_view"
} 

